import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../actions/api';
export const fetchPaymentDashboardData = createAsyncThunk(
  'paymentDashboard/fetchPaymentDashboardData',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api({ auth: true }).get('/clinic/dashboard/payments');
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch payment dashboard data');
    }
  }
);

const paymentDashboardSlice = createSlice({
  name: 'paymentDashboard',
  initialState: {
    totalSale: 0,
    totalPurchase: 0,
    unpaidCount: 0,
    unpaidTotal: 0,

    vetWiseBilling: {},
    top5ServiceTypesByCompletedAppointments: [],

    revenueReport: {},
    paymentModeCounts: [],
    collectionsHealth: {},
    revenueBySource: {},
    paymentMethodMix: {},
    outstandingAging: {},
    revenueByCategory: {},

    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPaymentDashboardData.fulfilled, (state, action) => {
        state.loading = false;

        // General Payment Data
        state.totalSale = action.payload.totalSale || 0;
        state.totalPurchase = action.payload.totalPurchase || 0;
        state.unpaidCount = action.payload.unpaidCount || 0;
        state.unpaidTotal = action.payload.unpaidTotal || 0;

        // Vet-wise Billing
        state.vetWiseBilling = action.payload.vetWiseBilling || {};
        state.top5ServiceTypesByCompletedAppointments =
          action.payload.top5ServiceTypesByCompletedAppointments || [];

        // Revenue & Payment Reports
        state.revenueReport = action.payload.revenueReport || {};
        state.paymentModeCounts = action.payload.paymentModeCounts || [];
        state.collectionsHealth = action.payload.collectionsHealth || {};
        state.revenueBySource = action.payload.revenueBySource || {};
        state.paymentMethodMix = action.payload.paymentMethodMix || {};
        state.outstandingAging = action.payload.outstandingAging || {};
        state.revenueByCategory = action.payload.revenueByCategory || {};
      })
      .addCase(fetchPaymentDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Something went wrong';
      });
  },
});

export default paymentDashboardSlice.reducer;